import { IPersonalInfoCmsMobile, IProduct } from '@vfit/consumer/data-access';

export const organizeConfirmIdentityCard = (
  dataFromCms: IPersonalInfoCmsMobile,
  product?: IProduct | null
) => ({
  titleCms: dataFromCms?.personalinfomobile?.clientRecognition?.title || '',
  descriptionCms: dataFromCms?.personalinfomobile?.clientRecognition?.description || '',
  placeholderCms: dataFromCms?.personalinfomobile?.selectInput?.contactPlaceholder || '',
  ctaLabelCms: dataFromCms?.personalinfomobile?.clientRecognition?.contactNotAccessLabel || '',
  ctaUrl:
    dataFromCms?.personalinfomobile?.clientRecognition?.contactNotAccessUrl ||
    product?.urlClickToCallOtp ||
    '',
});

